export default "__VITE_ASSET__DxsVTFx6__"